import { fg } from '@atlassian/jira-feature-gating';
import type { GetProjectSettingsUrl } from './types.tsx';

export const getProjectSettingsIssueTypesUrl = ({
	projectKey,
	projectType,
	isSimplifiedProject,
	issueTypeId,
}: GetProjectSettingsUrl): string => {
	if (fg('work_type_inline_config_nin_icc_fg')) {
		return getProjectSettingsIssueTypesNew({
			projectKey,
			projectType,
			isSimplifiedProject,
			...(fg('work_type_inline_config_nin_icc_fast_follow') ? { issueTypeId } : {}),
		});
	}

	return getProjectSettingsIssueTypesOld({ projectKey, projectType });
};

export const getProjectSettingsIssueTypesOld = ({
	projectKey,
	projectType,
}: GetProjectSettingsUrl): string => {
	switch (projectType?.toLowerCase()) {
		case 'customer_service':
		case 'service_desk':
			return `/plugins/servlet/project-config/${projectKey}/issueTypes`;
		case 'business':
			return `/jira/core/projects/${projectKey}/settings/issuetypes`;
		default:
			return `/jira/software/projects/${projectKey}/settings/issuetypes`;
	}
};

export const getProjectSettingsIssueTypesNew = ({
	projectKey,
	projectType,
	isSimplifiedProject,
	issueTypeId,
}: GetProjectSettingsUrl): string => {
	switch (projectType?.toLowerCase()) {
		case 'customer_service':
		case 'service_desk':
			return `/plugins/servlet/project-config/${projectKey}/issuetypes`;
		case 'business':
			return getBusinessProjectSettingsUrl({ projectKey, isSimplifiedProject, issueTypeId });
		case 'software':
			return getSoftwareProjectSettingsUrl({ projectKey, isSimplifiedProject, issueTypeId });
		default:
			return `/jira/software/projects/${projectKey}/settings/issuetypes`;
	}
};

const getSoftwareProjectSettingsUrl = ({
	projectKey,
	isSimplifiedProject,
	issueTypeId,
}: GetProjectSettingsUrl) =>
	isSimplifiedProject !== undefined && !isSimplifiedProject
		? `/plugins/servlet/project-config/${projectKey}/issuetypes`
		: `/jira/software/projects/${projectKey}/settings/issuetypes${issueTypeId && fg('work_type_inline_config_nin_icc_fast_follow') ? `/${issueTypeId}` : ''}`;

const getBusinessProjectSettingsUrl = ({
	projectKey,
	isSimplifiedProject,
	issueTypeId,
}: GetProjectSettingsUrl) =>
	isSimplifiedProject !== undefined && !isSimplifiedProject
		? `/plugins/servlet/project-config/${projectKey}/issuetypes`
		: `/jira/core/projects/${projectKey}/settings/issuetypes${issueTypeId && fg('work_type_inline_config_nin_icc_fast_follow') ? `/${issueTypeId}` : ''}`;
